import { useLegoland } from 'legoland-sdk/dist/experimental';
import { createUninitializedApiClient } from 'legoland-sdk/dist/experimental/apiClientUtils';
import { createContext, useContext, useEffect, useState } from 'react';
import { apiParts } from "./apiParts";
import { createAppApiClient } from "./createAppApiClient";
import { jsx as _jsx } from "react/jsx-runtime";
const uninitializedClient = createUninitializedApiClient('App');
const AppApiClientContext = /*#__PURE__*/createContext(uninitializedClient);
export const AppApiClientConsumer = AppApiClientContext.Consumer;
export function useAppApiClient() {
  return useContext(AppApiClientContext);
}
export const AppApiClientProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    legolandApiUrl
  } = useLegoland();
  const [client, setClient] = useState();
  useEffect(function onMountEffect() {
    setClient(createAppApiClient({
      baseUrl: legolandApiUrl
    }, apiParts));
  }, []);
  if (!client) return null;
  return /*#__PURE__*/_jsx(AppApiClientContext.Provider, {
    value: client,
    "data-sentry-element": "unknown",
    "data-sentry-component": "AppApiClientProvider",
    "data-sentry-source-file": "AppApiClientContext.tsx",
    children: children
  });
};